import useScrollTo from '@/composables/useScrollTo';
import { State } from '@/store/index';
import { Module } from 'vuex';

const { scrollToFirstBlock } = useScrollTo();

const getDefaultState = () => ({
  mountedStep: 0 as number,
  currentStep: 1 as number,
  allowedSteps: [1, 2, 3, 4, 5] as Array<number>,
  expandedStep: 1 as number | null,
  lastStep: 5 as number,
  stepCompletionStatus: [false, false, false, false, false] as Array<boolean>,
  miceReservation: true,
  hotelReservation: true,
});

export type formStepsState = ReturnType<typeof getDefaultState>;

export const FormSteps: Module<formStepsState, State> = {
  namespaced: true,

  state: getDefaultState(),

  mutations: {
    incrementStep(state: formStepsState) {
      if (state.currentStep < state.lastStep) {
        state.currentStep++;

        if (state.currentStep === 2 && !state.miceReservation) {
          state.currentStep++;
        }

        if (state.currentStep === 3 && !state.hotelReservation) {
          state.currentStep++;
        }

        state.expandedStep = state.currentStep;

        scrollToFirstBlock();
      }
    },

    decrementStep(state: formStepsState) {
      if (state.currentStep > 1) {
        state.currentStep--;

        if (state.currentStep === 3 && !state.hotelReservation) {
          state.currentStep--;
        }

        if (state.currentStep === 2 && !state.miceReservation) {
          state.currentStep--;
        }

        state.expandedStep = state.currentStep;

        scrollToFirstBlock();
      }
    },

    setStep(state: formStepsState, step: number) {
      if (state.currentStep === step && state.expandedStep !== null) {
        state.expandedStep = null;
        return;
      }

      // Allow navigation to step if it's less than or equal to current step
      // or if previous steps are completed
      if (
        step > state.currentStep &&
        !state.stepCompletionStatus
          .filter((value: boolean, index: number) => index < step - 1)
          .every((valid: boolean) => valid)
      ) {
        return;
      }

      if (state.currentStep !== step) {
        scrollToFirstBlock();
      }

      state.currentStep = step;
      state.expandedStep = step;
    },

    setStepComplete(state: formStepsState, step: number) {
      if (step in state.allowedSteps) {
        state.stepCompletionStatus[step - 1] = true;
      }
    },

    setMiceReservation(state: formStepsState, isMiceReservation: boolean) {
      state.miceReservation = isMiceReservation;
    },

    setHotelReservation(state: formStepsState, isHotelReservation: boolean) {
      state.hotelReservation = isHotelReservation;
    },

    setStepIncomplete(state: formStepsState, step: number) {
      if (step in state.allowedSteps) {
        state.stepCompletionStatus[step - 1] = false;
      }
    },

    setMountedStep(state: formStepsState, step: number) {
      state.mountedStep = step;
    },
  },
};
